import React, { useEffect, useState } from "react";
import "./GetResearchExperience.css";
import GetResearchExperienceTiles from "./GetResearchExperienceTiles";
import { fetchResourceTilesByTagFilters, TaggedResourceTiles } from "../../utils/contentful-helpers";

const GetResearchExperience = () => {
  const [taggedResourceTiles, setTaggedResourceTiles] = useState<TaggedResourceTiles[]>([]);

  useEffect(() => {
    const tagFilters = ["Research Up Tiles", "Research Down Tiles"];
    fetchResourceTilesByTagFilters(tagFilters).then((results) => {
      setTaggedResourceTiles(results);
    });
  }, []);

  const getSectionTitle = (tagFilter: string) => {
    switch (tagFilter) {
      case "Research Up Tiles":
        return "Check out the research opportunities available in our Department, to get started:";
      case "Research Down Tiles":
        return "If you would like to find research opportunities elsewhere, here are some good ways to get started:";
      default:
        return "";
    }
  };

  return (
    <div>
      <div className={`get-research-experience`}>
        <div>
          <p className="title">
            Looks like you want to get more research experience!
          </p>
          {taggedResourceTiles.map((section, index) => (
            <div key={section.tagFilter}>
              {index > 0 && <span style={{ display: "inline-block", height: "10px" }}></span>}
              {index > 0 && <p className="research-highlighted-paragraph"></p>}
              <p className="research-highlighted-paragraph">
                {getSectionTitle(section.tagFilter)}
              </p>
              <GetResearchExperienceTiles resourceTiles={section.data} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GetResearchExperience;
